// ---------------------------------------------------------------------------
// Toast — transient confirmation pill (ring queued, acknowledged, CSV saved…).
// ---------------------------------------------------------------------------
import React from "react";

function Toast({msg}) {
    return <div className={`toast ${msg ? "show" : ""}`}>{msg}</div>;
}

export default Toast;
